<template lang="pug">
  articles-feed(title="Index", :articles="articles")
</template>

<script>
import ArticlesFeed from '@/components/ArticlesFeed'
export default {
  name: 'Library__Feed',
  components: { ArticlesFeed },
  computed: {
    articles () {
      return this.$store.state.articles
    }
  },
  created () {
    this.$store.dispatch('getArticles')
  }
}
</script>

<style>
</style>
